import { useState } from "react";
import { formatMoney, parseMoney } from "@shared/formatters/money";

/**
 * Dollar amount field. Shows "$8,097.64" at rest; while focused it keeps the
 * raw text you're typing (so "8097." isn't reformatted away mid-entry) and
 * reports the parsed number on every change.
 */
export default function MoneyInput({ value, onChange, className = "", style, ...rest }) {
  const [draft, setDraft] = useState(null); // raw text while editing; null at rest
  return (
    <input
      type="text"
      inputMode="decimal"
      value={draft ?? formatMoney(value)}
      onFocus={(e) => {
        const n = Number(value) || 0;
        setDraft(n ? String(n) : "");
        requestAnimationFrame(() => e.target.select());
      }}
      onChange={(e) => {
        const text = e.target.value.replace(/[^0-9.]/g, "").replace(/(\..*?)\./g, "$1");
        setDraft(text);
        onChange(parseMoney(text));
      }}
      onBlur={() => setDraft(null)}
      onKeyDown={(e) => { if (e.key === "Enter") e.currentTarget.blur(); }}
      className={className}
      style={style}
      {...rest}
    />
  );
}
